import Footer from "./components/Footer";
import { Outlet } from "react-router-dom";

function App() {
    return (
        <div className="grid grid-rows-page min-h-screen">
            <Outlet />
            <Footer />
        </div>
    );
}

export default App;
